export const tableData = [{
    id:1,
    name: "网页模板",
    keyword: "网页模板",
    description: "网页模板",
    seoTitle: "网页模板",
    children: [{
        id:11,
        name: "医疗保健",
        keyword: "医疗保健",
        description: "医疗保健",
        seoTitle: "医疗保健",
    },{
        id:12,
        name: "文章资讯",
        keyword: "文章资讯",
        description: "文章资讯",
        seoTitle: "文章资讯",
    }]
}];